import React, { useState } from "react";
import * as cls from "./lastDiscipLearning.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { TableLoader } from "../tableLoader";
import { TableModel } from "../../../personal-studio-components/table/TableModel";
import { StudentService } from "../studentService";
import {
  showZetLessonDetailAction,
  zetLessonDetailDataAction,
} from "../../redux/actions/actions";

export default function LastDiscipLearning({ menu }) {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);

  const dispatch = useDispatch();
  const getLessons = async (id, discip_short_name, zet_name, row) => {
    // if (is_paid === 0) return;
    console.assert(id);
    const request = {
      method: "post",
      path: "/student/linegraph/discip/lessons",
      data: {
        access_token,
        study_contract_id: contractId,
        semester_id: row.semester_id,
        ind_mod_discip_id: row.ind_mod_discip_id,
      },
    };
    dispatch(showZetLessonDetailAction(true));
    await StudentService.send(request, (response) => {
      if (response) {
        dispatch(
          zetLessonDetailDataAction({
            lessons: response,
            discip_short_name,
            zet_name,
          })
        );
      }
    });
  };

  const loader = {
    // title: "Последние действия", // Переопределено ниже
    // icon: "book_open", // Переопределено ниже
    request: {
      method: "post",
      path: "/student/widget/last_discip_learning",
      data: {
        access_token,
        study_contract_id: contractId,
        return_row_value: 0,
      },
    },
    parser: createModel,
  };
  function createModel(response) {
    const table = new TableModel(response);
    table.columns = table.columns.filter(
      (el) => el.field !== "payment_queue_module_id" && el.field !== "zet_name"
    );
    table.columns.forEach((col) => {
      if (col.field === "start_date") {
        col.type = "date";
      }
      if (col.field === "percent_complete") {
        col.type = "jsx";
      }
    });
    table.rows = table.rows.map((row) => {
      return {
        ...row,
        onClick: () => {
          getLessons(
            row.payment_queue_module_id,
            row.mod_discip_name,
            row.zet_name,
            row
          );
        },
        percent_complete: (
          <div>
            {" "}
            <progress
              max="100"
              value={row.percent_complete}
              className={cls.progress}
            />
          </div>
        ),
      };
    });
    //table.maxHeight = "20rem";
    return table;
  }
  return (
    <TableLoader
      {...loader}
      menu={menu}
      type="blue"
      icon={"folder_open"}
      title={"Последние действия"}
    />
  );
}
